import { useState } from 'react';

import { Button } from 'antd';

import Info from '@/components/icons/Info';
import ImportantInformation from '@/components/modals/ImportantInformation';
import useStepStore, { type Step } from '@/stores/steps';

type InformationProps = {
  type?: 'button' | 'link';
  contentToIgnore?: Step['content'][];
};

const Information = ({ type = 'link', contentToIgnore = [] }: InformationProps) => {
  const [openInfo, setOpenInfo] = useState(false);
  const currentStepData = useStepStore(state => state.stepData);

  if (currentStepData && contentToIgnore.includes(currentStepData.content)) {
    return null;
  }

  return (
    <>
      {type === 'link' && (
        <Button
          id='info-modal-open-link'
          type='link'
          size='small'
          className='lg:hidden!'
          onClick={() => setOpenInfo(!openInfo)}
        >
          <Info />
        </Button>
      )}

      {type === 'button' && (
        <Button
          id='info-modal-open-button'
          className='override-button-base! hidden! lg:flex!'
          onClick={() => setOpenInfo(!openInfo)}
        >
          <Info className='h-4.5! w-4.5!' />
          Informações
        </Button>
      )}

      <ImportantInformation openInfo={openInfo} setOpenInfo={setOpenInfo} />
    </>
  );
};

export default Information;
